"use client";

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { useEffect } from "react";

// Module-level (không phải React state/ref) — chia sẻ đồng bộ giữa MỌI component dùng hook này
// trong cùng 1 lần load trang. Redux `called` chỉ được set SAU khi API trả về nên không đủ nhanh để
// chặn 2 component mount cùng lúc (SelectCountry + EsimDiscoverByGroup) cùng bắn request; biến này
// được set ngay lập tức (đồng bộ) nên chặn được cả trường hợp đó. Reset khi tab reload (như bên dưới).
let hasRequestedEsimFilters = false;

/**
 * Distinct `data`/`validity`/`parentGroupName` options for the search form (`POST /esim/catalog/public/filters`,
 * api_guide mục 3.5). Fetch đúng 1 lần/tab, mọi consumer (SelectCountry, EsimDiscoverByGroup, ...)
 * dùng chung kết quả — API không có TTL, chỉ đổi khi admin sync nên không cần gọi lại mỗi lần mount.
 */
export const useEsimCatalogFilters = () => {
  const dispatch = useAppDispatch();
  const { data, validity, parentGroupName, loading, called } = useAppSelector((state) => ({
    data: state.esim.esim_catalog_public_filters.data.data,
    validity: state.esim.esim_catalog_public_filters.data.validity,
    parentGroupName: state.esim.esim_catalog_public_filters.data.parentGroupName,
    loading: state.esim.esim_catalog_public_filters.loading,
    called: state.esim.esim_catalog_public_filters.called,
  }));

  useEffect(() => {
    if (called || hasRequestedEsimFilters) return;
    hasRequestedEsimFilters = true;
    dispatch(
      thunks.esim_catalog_public_filters({
        body: { TYPE: "JSON", data: true, validity: true, parentGroupName: true },
      }),
    );
  }, [called, dispatch]);

  return { dataOptions: data, validityOptions: validity, parentGroupNameOptions: parentGroupName, loading };
};
